<template>
    <div class="main-page__filter filter-main-page">
        <div class="filter-main-page__item">
            <div class="filter-main-page__title">{{ 'Property type' | trans }}</div>
            <div
                key="propertyTypesFilterMain"
                class="filter-main-page__select select-filter-main-page"
                :class="{'open': openedFilters.propertyTypesFilter}"
            >
                <button
                    type="button"
                    key="propertyTypesFilterSelectedMain"
                    class="select-filter-main-page__title"
                    @click.stop="hideShowFilterSelectedMain('propertyTypesFilter')"
                >
                    <span class="select-filter-title-wrap">
                        <span
                            v-if="localSelectedPropertyTypes.length === 0"
                            key="anySelectedPropertyTypeMain"
                        >
                            {{ 'All' | trans }}
                        </span>
                        <span
                            v-else
                            key="selectedTypesMain"
                        >
                            {{ printSelectedItems(localSelectedPropertyTypes) }}
                        </span>
                    </span>
                    <span class="select-filter-main-page__arr _icon-select_arr"></span>
                </button>
                <div class="select-filter-main-page__body">
                    <div class="select-filter-wrap" data-simplebar>
                        <div
                            key="allSelectedPropertyTypesMain"
                            class="select-filter-main-page__item"
                            :class="{'_active': areAllPropertyTypesChecked}"
                            @click="toggleItem(localSelectedPropertyTypes)"
                        >
                            {{ 'All' | trans }}
                        </div>
                        <div
                            :key="'propertyTypeMain' + index"
                            v-for="(propertyType, index) in allPropertyTypes"
                            class="select-filter-main-page__item"
                            :class="{'_active': isSelectedItem(propertyType, localSelectedPropertyTypes)}"
                            @click="toggleItem(localSelectedPropertyTypes, propertyType)"
                        >
                            {{ propertyType.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-main-page__item">
            <div class="filter-main-page__title">{{ 'District' | trans }}</div>
            <div
                key="districtsFilterMain"
                class="filter-main-page__select select-filter-main-page"
                :class="{'open': openedFilters.districtsFilter}"
            >
                <button
                    type="button"
                    key="districtsFilterSelectedMain"
                    class="select-filter-main-page__title"
                    @click.stop="hideShowFilterSelectedMain('districtsFilter')"
                >
                    <span class="select-filter-title-wrap">
                        <span
                          v-if="localSelectedDistricts.length === 0"
                          key="anySelectedDistrictMain"
                        >
                            {{ 'All' | trans }}
                        </span>
                        <span
                          v-else
                          key="selectedDistrictsMain"
                        >
                            {{ printSelectedItems(localSelectedDistricts)}}
                        </span>
                    </span>
                    <span class="select-filter-main-page__arr _icon-select_arr"></span>
                </button>
                <div class="select-filter-main-page__body">
                    <div class="select-filter-wrap" data-simplebar>
                        <div
                            key="allSelectedDistrictsMain"
                            class="select-filter-main-page__item"
                            :class="{'_active': areAllDistrictsChecked}"
                            @click="toggleItem(localSelectedDistricts)"
                        >
                            {{ 'All' | trans }}
                        </div>
                        <div
                            v-for="district in allDistricts"
                            :key="'districtMain' + district.id"
                            class="select-filter-main-page__item"
                            :class="{'_active': isSelectedItem(district, localSelectedDistricts)}"
                            @click="toggleItem(localSelectedDistricts, district)"
                        >
                            {{ district.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-main-page__item filter-main-page__item_inputs">
            <div class="filter-main-page__title">{{ 'Price in' | trans }} {{ currency }}</div>
            <div class="filter-main-page__inputs inputs-filter-main-page">
                <div class="inputs-filter-main-page__item">
                    <input
                        type="text"
                        name=""
                        :placeholder="'From 500,000' | trans"
                        class="inputs-filter-main-page__input"
                        v-model="localSelectedMinPrice"
                    >
                </div>
                <div class="inputs-filter-main-page__item">
                    <input
                        type="text"
                        name=""
                        :placeholder="'Up to 3,000,000' | trans"
                        class="inputs-filter-main-page__input"
                        v-model="localSelectedMaxPrice"
                    >
                </div>
            </div>
        </div>
        <button
            key="searchButtonMain"
            type="button"
            class="filter-main-page__submit _icon-search"
            @click="applyFilteringOptions"
        >
        </button>
        <button
            key="openPopupFilterMain"
            type="button"
            data-popup=".popup-filter"
            class="filter-main-page__btn _icon-filter"
        >
        </button>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "MainPageFilter",
    props: {
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            turnOnWatchers: true,
            openedFilters: {
                propertyTypesFilter: false,
                districtsFilter: false,
            },
            localSelectedPropertyTypes: [],
            localSelectedDistricts: [],
            localSelectedMinPrice: '',
            localSelectedMaxPrice: '',
            localSelectedIsNew: null,
        }
    },
    computed: {
        ...mapGetters({
            selectedPropertyTypesFromStore:   'filtration/selectedPropertyTypes',
            selectedDistrictsFromStore:       'filtration/selectedDistricts',
            selectedMinPriceFromStore:        'filtration/selectedMinPrice',
            selectedMaxPriceFromStore:        'filtration/selectedMaxPrice',
            selectedBuildersFromStore:        'filtration/selectedBuilders',
            selectedComplexesFromStore:       'filtration/selectedComplexes',
            selectedBedroomsNumberFromStore:  'filtration/selectedBedroomsNumber',
            selectedBathroomsNumberFromStore: 'filtration/selectedBathroomsNumber',
            selectedPersonalIdFromStore:      'filtration/selectedPersonalId',
            selectedIsFinishedFromStore:      'filtration/selectedIsFinished',
            selectedHighestPriceFromStore:    'filtration/selectedHighestPrice',
            selectedLowestPriceFromStore:     'filtration/selectedLowestPrice',
            selectedIsNewFromStore:           'filtration/selectedIsNew',
            selectedIsPopularFromStore:       'filtration/selectedIsPopular',
        }),
        currency() {
            return window.currentCurrency;
        },
        allPropertyTypes() {
            return this.options.allPropertyTypes
        },
        allDistricts() {
            return this.options.allDistricts
        },
        areAllPropertyTypesChecked: {
            get() {
                return this.localSelectedPropertyTypes.length === 0;
            },
            set(value) {
                if (value && this.localSelectedPropertyTypes.length !== 0) {
                    this.localSelectedPropertyTypes = [];
                }
            }
        },
        areAllDistrictsChecked: {
            get() {
                return this.localSelectedDistricts.length === 0;
            },
            set(value) {
                if (value && this.localSelectedDistricts.length !== 0) {
                    this.localSelectedDistricts = [];
                }
            }
        },
    },
    methods: {
        ...mapActions({
            redirectToPropertiesPage:        'filtration/redirectToPropertiesPage',
            setSelectedMinPriceToStore:      'filtration/setSelectedMinPrice',
            setSelectedMaxPriceToStore:      'filtration/setSelectedMaxPrice',
            setSelectedPropertyTypesToStore: 'filtration/setSelectedPropertyTypes',
            setSelectedDistrictsToStore:     'filtration/setSelectedDistricts'
        }),
        toggleItem(selectedItems, item = null) {
            if (item === null) {
                if (selectedItems.length !== 0) {
                    selectedItems.splice(0, selectedItems.length);
                }
                return;
            }
            const index = selectedItems.findIndex(selected => selected.id === item.id)
            if (index !== -1) {
                selectedItems.splice(index, 1)
            } else {
                selectedItems.push(item)
            }
        },
        isSelectedItem(item, selectedItems) {
            return selectedItems.some(selected => selected.id === item.id)
        },
        printSelectedItems(selectedItems) {
            return selectedItems.map(item => item.title).join(', ')
        },
        applyFilteringOptions() {
            this.redirectToPropertiesPage();
        },
        hideShowFilterSelectedMain(openedFilter){
            Object.keys(this.openedFilters).forEach(key => {
                if (openedFilter !== key) {
                    this.openedFilters[key] = false;
                } else {
                    this.openedFilters[key] = !this.openedFilters[key];
                }
            });
        },
        hideAllFilterSelectedMain(event){
            // не скрываем выпадающий список, если нажат элемент списка
            if (!event.target.closest('.select-filter-main-page__body')) {
                Object.keys(this.openedFilters).forEach(key => {
                    this.openedFilters[key] = false;
                });
            }
        }
    },
    watch: {
        selectedPropertyTypesFromStore(newVal) {
            this.turnOnWatchers = false
            this.localSelectedPropertyTypes = Array.isArray(newVal) ? [...newVal] : [];
            this.$nextTick(() => {
                this.turnOnWatchers = true
            })
        },
        localSelectedPropertyTypes(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedPropertyTypesToStore({selectedPropertyTypes: newVal})
            }
        },
        selectedDistrictsFromStore(newVal) {
            this.turnOnWatchers = false
            this.localSelectedDistricts = Array.isArray(newVal) ? [...newVal] : [];
            this.$nextTick(() => {
                this.turnOnWatchers = true
            })
        },
        localSelectedDistricts(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedDistrictsToStore({selectedDistricts: newVal})
            }
        },
        selectedMinPriceFromStore(newVal) {
            this.turnOnWatchers = false
            this.localSelectedMinPrice = newVal;
            this.$nextTick(() => {
                this.turnOnWatchers = true
            })
        },
        localSelectedMinPrice(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedMinPriceToStore({selectedMinPrice: newVal});
            }
        },
        selectedMaxPriceFromStore(newVal) {
            this.turnOnWatchers = false
            this.localSelectedMaxPrice = newVal;
            this.$nextTick(() => {
                this.turnOnWatchers = true
            })
        },
        localSelectedMaxPrice(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedMaxPriceToStore({selectedMaxPrice: newVal})
            }
        },
    },
    mounted() {
        if (this.selectedPropertyTypesFromStore) {
            this.localSelectedPropertyTypes = [...this.selectedPropertyTypesFromStore];
        }
        if (this.selectedDistrictsFromStore) {
            this.localSelectedDistricts = [...this.selectedDistrictsFromStore];
        }
        if (this.selectedMinPriceFromStore !== null) {
            this.localSelectedMinPrice = this.selectedMinPriceFromStore;
        }
        if (this.selectedMaxPriceFromStore !== null) {
            this.localSelectedMaxPrice = this.selectedMaxPriceFromStore;
        }

        document.addEventListener('click', this.hideAllFilterSelectedMain);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.hideAllFilterSelectedMain);
    },
}
</script>
